
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityMergeSourceGrid extends SiteEntityGrid<SecurityMergeSourceRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMergeSource'; }
        protected getDialogType() { return SecurityMergeSourceDialog; }
        protected getIdProperty() { return SecurityMergeSourceRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeSourceRow.localTextPrefix; }
        protected getService() { return SecurityMergeSourceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}